import Hero from './components/Hero';
import Mission from './components/Mission';
import CoreProblem from './components/CoreProblem';
import PolicyFramework from './components/PolicyFramework';
import StrategicFocus from './components/StrategicFocus';
import Leadership from './components/Leadership';
import Advisory from './components/Advisory';
import ContactSection from './components/ContactSection';
import Footer from '../home/components/Footer';

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-white">
      <Hero />
      
      {/* Official Launch Announcement */}
      <section className="py-12 px-6 bg-teal-50">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-lg p-8 shadow-lg border-l-4 border-teal-600">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                <i className="ri-megaphone-line text-2xl text-teal-600"></i>
              </div>
              <div className="flex-1">
                <h3 className="text-2xl font-bold text-gray-900 mb-3">
                  Official Launch: California Secretary of State Approval
                </h3>
                <p className="text-gray-700 mb-4 leading-relaxed">
                  The Algorithmic Consistency Initiative has been officially approved by the California Secretary of State as a registered policy research organization and think tank. Led by Angel Luevano, lead plaintiff in the historic <strong className="text-teal-700">Luevano v. Campbell</strong> case, ACI brings decades of civil rights advocacy to the challenge of AI governance.
                </p>
                <a 
                  href="/newsroom"
                  className="inline-flex items-center gap-2 text-teal-700 hover:text-teal-800 font-semibold cursor-pointer"
                >
                  Read the Full Press Release
                  <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Mission />
      <CoreProblem />
      <StrategicFocus />
      <PolicyFramework />
      <Leadership />
      <Advisory />
      <ContactSection />
      <Footer />
    </div>
  );
}
